import React, { useEffect, useState, useContext, useRef } from "react";
import { CartContext } from "../CartContext";
import { Link, useNavigate, useLocation } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import logo from "../assets/logo.jpg";
import _ from "lodash";
import axios from "axios";
import Collapse from "bootstrap/js/dist/collapse"; // add this at the top


const CATEGORY_LIST = [
  { name: "Face", slug: "face-care" },
  { name: "Hair", slug: "hair-care" },
  { name: "Body", slug: "body-care" },
  { name: "Offer", slug: "special-offer" },
];

const Navbar = ({ user, setUser }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { cart } = useContext(CartContext);
  const cartCount = cart.reduce((sum, item) => sum + (item.quantity || 1), 0);

  const [searchTerm, setSearchTerm] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [placeholderIndex, setPlaceholderIndex] = useState(0);

  const searchRef = useRef(null);

  const placeholders = [
    "Search Products...",
    "Try Heena Powder...",
    "Type Powdered Shampoo...",
    "Body Soap...",
  ];

  // Rotate placeholder text
  useEffect(() => {
    AOS.init({ duration: 600, once: true });
    const interval = setInterval(() => {
      setPlaceholderIndex((prev) => (prev + 1) % placeholders.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  // Restore user if token exists
  useEffect(() => {
    const token = localStorage.getItem("token");
    const storedUser = localStorage.getItem("user");

    if (token && storedUser) {
      try {
        const parsedUser = JSON.parse(storedUser);
        setUser(parsedUser);
      } catch (err) {
        console.error("Invalid user in localStorage", err);
        setUser(null);
      }
    }
  }, [setUser, location.pathname]);

  // Debounced API search
  const handleSearch = _.debounce(async (term) => {
    if (term.length > 0) {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_URL}/products?search=${term}`
        );
        setSuggestions(res.data);
      } catch (err) {
        console.error("Error fetching products:", err);
        setSuggestions([]);
      }
    } else {
      setSuggestions([]);
    }
  }, 400);

  const onSearchChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    handleSearch(value);
  };

  // Close dropdown on outside click
  useEffect(() => {
    function handleClickOutside(event) {
      if (searchRef.current && !searchRef.current.contains(event.target)) {
        setSuggestions([]);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("local_cart");
    localStorage.removeItem("isAdmin");
    localStorage.removeItem("isLoggedIn");
    setUser(null);
    navigate("/login");
  };

  // Detect mobile
  const isMobile = window.innerWidth <= 700;

  // 🔹 Auto-close navbar on route change
 useEffect(() => {
  const navbarCollapse = document.getElementById("navbarNav");
  if (navbarCollapse && navbarCollapse.classList.contains("show")) {
    const collapse = Collapse.getInstance(navbarCollapse) || new Collapse(navbarCollapse, { toggle: false });
    collapse.hide();
  }
}, [location.pathname]);


  return (
    <nav
      className="navbar navbar-expand-lg navbar-dark sticky-top shadow rounded py-2"
      style={{
        backgroundColor: "#FFFAF0",
        zIndex: 1050,
        marginTop: "0",
        padding: "0",
      }}
    >
      <div className="container-fluid px-4" style={{ position: "relative" }}>
        {/* Logo */}
        <Link className="navbar-brand d-flex align-items-center" to="/">
          <img
            src={logo}
            width="60"
            height="50"
            style={{ borderRadius: "10%", backgroundColor: "black" }}
            className="d-inline-block align-top"
            alt="logo"
          />
          <div
            className="ms-2 fw-bold text-center"
            style={{
              fontSize: "1.4rem",
              color: "#834333",
              textShadow: "1px 1px 3px rgba(0, 0, 0, 0.5)",
              fontFamily: "Roboto Slab, serif",
              lineHeight: "1.1",
            }}
          >
            <div style={{ fontWeight: "bold", letterSpacing: "1px" }}>
              ROUPAN
            </div>
            <div
              style={{
                fontSize: "1.3rem",
                color: "#834333",
                fontWeight: "bold",
                textShadow: "1px 1px 3px rgba(0, 0, 0, 0.5)",
                letterSpacing: "2px",
              }}
            >
              NATURALS
            </div>
          </div>
        </Link>

        {/* Mobile Toggle */}
        <button
          className="navbar-toggler bg-dark"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
        >
          <span className="navbar-toggler-icon bg-dark"></span>
        </button>

        {/* Nav Links */}
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav me-auto mb-2 mb-lg-0 mx-5 text-dark ">
            {["Home", "Products", "About_us", "Contact", "Gift_Hampers"].map(
              (label, index) => (
                <li
                  className="nav-item mx-2 fw-bolder text-dark"
                  key={label}
                  data-aos="fade-down"
                  data-aos-delay={(index + 1) * 150}
                  style={{ transition: "all 0.3s ease" }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-3px)";
                    e.currentTarget.style.textShadow =
                      "0px 3px 6px rgba(0,0,0,0.15)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0px)";
                    e.currentTarget.style.textShadow = "none";
                  }}
                >
                  <Link
                    className="nav-link text-dark"
                    style={{
                      fontSize: "1.00rem",
                      fontWeight: "600",
                      padding: "7px 5px",
                      borderRadius: "8px",
                      transition: "all 0.3s ease",
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.color = "#834333";
                      e.target.style.background = "rgba(131,67,51,0.1)";
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.color = "#000";
                      e.target.style.background = "transparent";
                    }}
                    to={`/${label.toLowerCase().replace("_", "")}`}
                  >
                    {label}
                  </Link>
                </li>
              )
            )}
            {/* Category Dropdown */}
            <li
              className="nav-item dropdown mx-2 fw-bolder text-dark"
              data-aos="fade-down"
              data-aos-delay="900"
              style={{ transition: "all 0.3s ease" }}
            >
              <a
                className="nav-link dropdown-toggle text-dark"
                href="#!"
                id="categoryDropdown"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Category
              </a>
              <ul
                className="dropdown-menu animate__animated animate__fadeIn text-dark"
                aria-labelledby="categoryDropdown"
                style={{
                  borderRadius: "12px",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                }}
              >
                {CATEGORY_LIST.map((cat) => (
                  <li
                    key={cat.slug}
                    style={{ transition: "all 0.3s ease" }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.background =
                        "rgba(131,67,51,0.08)";
                      e.currentTarget.style.transform = "translateX(5px)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.background = "transparent";
                      e.currentTarget.style.transform = "translateX(0px)";
                    }}
                  >
                    <Link
                      className="dropdown-item text-dark"
                      to={`/category/${cat.slug}`}
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </li>
          </ul>

          {/* Search Bar */}
          <form
            ref={searchRef}
            className="d-flex position-relative mx-auto"
            data-aos="fade-down"
            style={{
              width: isMobile ? "98vw" : "300px",
              maxWidth: "98vw",
              zIndex: 2000,
            }}
          >
            <input
              className="form-control me-2 rounded-pill px-4"
              type="search"
              placeholder={placeholders[placeholderIndex]}
              aria-label="Search"
              value={searchTerm}
              onChange={onSearchChange}
              style={{
                fontSize: isMobile ? "1.1rem" : "1rem",
                minWidth: isMobile ? "90vw" : "auto",
                background: "#fff",
                border: "1.5px solid #e2e2e2",
                boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
              }}
            />
            <i
              className="bi bi-search position-absolute"
              style={{
                right: "15px",
                top: "50%",
                transform: "translateY(-50%)",
                color: "#555",
              }}
            ></i>

            {/* Suggestions Overlay */}
            {suggestions.length > 0 && (
              <>
                {/* Backdrop Overlay (mobile only) */}
                {isMobile && (
                  <div
                    onClick={() => setSuggestions([])}
                    style={{
                      position: "fixed",
                      inset: 0,
                      zIndex: 7999,
                      background: "rgba(0,0,0,0.01)",
                    }}
                  ></div>
                )}

                <ul
                  style={{
                    position: "absolute",
                    top: "110%",
                    left: 0,
                    width: isMobile ? "98vw" : "100%",
                    minWidth: isMobile ? "98vw" : "260px",
                    zIndex: isMobile ? 8000 : 1500,
                    background: "#fff",
                    borderRadius: "12px",
                    boxShadow: "0 6px 24px rgba(0,0,0,0.13)",
                    padding: 0,
                    margin: 0,
                    listStyle: "none",
                    maxHeight: isMobile ? "60vh" : "320px",
                    overflowY: "auto",
                  }}
                >
                  {suggestions.map((item) => (
                    <li
                      key={item.id}
                      style={{
                        borderBottom: "1px solid #f0f0f0",
                        cursor: "pointer",
                        fontSize: "1rem",
                        padding: "12px 18px",
                        background: "#fff",
                        transition: "background 0.15s",
                      }}
                      onClick={() => {
                        navigate(`/products/${item.id}`);
                        setSearchTerm("");
                        setSuggestions([]);
                      }}
                      onMouseDown={(e) => e.preventDefault()} // Prevent input blur
                      onMouseEnter={(e) =>
                        (e.currentTarget.style.background =
                          "rgba(131,67,51,0.08)")
                      }
                      onMouseLeave={(e) =>
                        (e.currentTarget.style.background = "#fff")
                      }
                    >
                      {item.name}
                    </li>
                  ))}
                </ul>
              </>
            )}
          </form>

          {/* User + Cart */}
          {!isMobile || suggestions.length === 0 ? (
            <ul className="navbar-nav ms-auto fw-bolder lh-2 text-dark">
              {!user ? (
                <>
                  <li
                    className="nav-item"
                    data-aos="fade-down"
                    data-aos-delay="650"
                  >
                    <Link
                      className="nav-link text-dark"
                      to="/login"
                      style={{ transition: "all 0.3s ease" }}
                      onMouseEnter={(e) => {
                        e.target.style.color = "#834333";
                        e.target.style.transform = "translateY(-2px)";
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.color = "#000";
                        e.target.style.transform = "translateY(0px)";
                      }}
                    >
                      Login
                    </Link>
                  </li>
                  <li
                    className="nav-item"
                    data-aos="fade-down"
                    data-aos-delay="750"
                  >
                    <Link
                      className="nav-link text-dark"
                      to="/register"
                      style={{ transition: "all 0.3s ease" }}
                      onMouseEnter={(e) => {
                        e.target.style.color = "#834333";
                        e.target.style.transform = "translateY(-2px)";
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.color = "#000";
                        e.target.style.transform = "translateY(0px)";
                      }}
                    >
                      Register
                    </Link>
                  </li>
                  <li className="nav-item mx-3">
                    <Link className="nav-link position-relative" to="/cart">
                      <button
                        className="btn btn-danger p-0"
                        style={{
                          transition: "transform 0.3s ease",
                        }}
                        onMouseEnter={(e) =>
                          (e.currentTarget.style.transform = "scale(1.1)")
                        }
                        onMouseLeave={(e) =>
                          (e.currentTarget.style.transform = "scale(1)")
                        }
                      >
                        <i
                          className="bi bi-cart-fill"
                          style={{ fontSize: "1.3rem" }}
                        ></i>
                      </button>
                      {cartCount > 0 && (
                        <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                          {cartCount}
                          <span className="visually-hidden">cart items</span>
                        </span>
                      )}
                      <span className="ms-1 text-dark">Cart</span>
                    </Link>
                  </li>
                </>
              ) : (
                <li
                  className="nav-item dropdown"
                  data-aos="fade-down"
                  data-aos-delay="650"
                  style={{ transition: "all 0.3s ease" }}
                >
                  <a
                    href="#!"
                    className="nav-link dropdown-toggle text-dark"
                    id="userDropdown"
                    role="button"
                    data-bs-toggle="dropdown"
                    style={{ cursor: "pointer" }}
                  >
                    {user.name}
                  </a>
                  <ul
                    className="dropdown-menu dropdown-menu-end animate__animated animate__fadeIn text-dark"
                    style={{
                      borderRadius: "12px",
                      boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                    }}
                  >
                    <li
                      className="nav-item mx-3"
                      style={{ transition: "all 0.3s ease" }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.background =
                          "rgba(131,67,51,0.08)";
                        e.currentTarget.style.transform = "translateX(5px)";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.background = "transparent";
                        e.currentTarget.style.transform = "translateX(0px)";
                      }}
                    >
                      <Link className="nav-link position-relative" to="/cart">
                        <i
                          className="bi bi-cart-fill"
                          style={{ fontSize: "1.3rem" }}
                        ></i>
                        {cartCount > 0 && (
                          <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                            {cartCount}
                            <span className="visually-hidden">cart items</span>
                          </span>
                        )}
                        <span className="ms-1 text-dark">Cart</span>
                      </Link>
                    </li>
                    <li
                      style={{ transition: "all 0.3s ease" }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.background =
                          "rgba(131,67,51,0.08)";
                        e.currentTarget.style.transform = "translateX(5px)";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.background = "transparent";
                        e.currentTarget.style.transform = "translateX(0px)";
                      }}
                    >
                      <Link className="dropdown-item text-dark" to="/orders">
                        Orders
                      </Link>
                    </li>
                    <li>
                      <hr className="dropdown-divider" />
                    </li>
                    <li
                      style={{ transition: "all 0.3s ease" }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.background =
                          "rgba(131,67,51,0.08)";
                        e.currentTarget.style.transform = "translateX(5px)";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.background = "transparent";
                        e.currentTarget.style.transform = "translateX(0px)";
                      }}
                    >
                      <button
                        className="dropdown-item text-dark"
                        onClick={handleLogout}
                      >
                        Logout
                      </button>
                    </li>
                  </ul>
                </li>
              )}
            </ul>
          ) : null}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
